(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5199],{

/***/ 50951:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fredcon25",
      function () {
        return __webpack_require__(69318);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 73412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45847);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var utils_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75339);
/* harmony import */ var _HeadMetadataLangAlternate__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21646);






var HeadMetadata = function(param) {
    var title = param.title, url = param.url, _desc = param.desc, desc = _desc === void 0 ? "" : _desc, imgUrl = param.imgUrl, path = param.path, _indexable = param.indexable, indexable = _indexable === void 0 ? false : _indexable, _extraMeta = param.extraMeta, extraMeta = _extraMeta === void 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}) : _extraMeta;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)().locale;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: desc || ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: desc || ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: imgUrl || "https://www.getmanfred.com/og-image.jpg"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:site",
                        content: "@getmanfred"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:creator",
                        content: "@getmanfred"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: desc || ""
                    }),
                    imgUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:image",
                        content: imgUrl
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: desc || ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:site_name",
                        content: "Get Manfred"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:locale",
                        content: locale
                    }),
                    url && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                property: "og:url",
                                content: "".concat(utils_config__WEBPACK_IMPORTED_MODULE_4__/* .config.appUrl */ .v.appUrl).concat(url.langs["es"])
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                                rel: "canonical",
                                href: "".concat(utils_config__WEBPACK_IMPORTED_MODULE_4__/* .config.appUrl */ .v.appUrl).concat(url.langs["es"])
                            })
                        ]
                    }),
                    indexable && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "robots",
                        content: "index,follow"
                    }),
                    extraMeta
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_3___default()), {
                id: "globalLDMetadata",
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: '{\n          "@context": "https://schema.org",\n          "@type": "Organization",\n          "name": "Manfred",\n          "url": "https://www.getmanfred.com/",\n          "logo": "https://www.getmanfred.com/favicon.ico",\n          "description": "Plataforma de empleo para profesionales del sector tecnol\xf3gico.",\n          "sameAs": [\n            "https://twitter.com/getmanfred",\n            "https://www.linkedin.com/company/getmanfred/",\n            "https://github.com/getmanfred>"\n          ],\n          "contactPoint": [\n            {\n              "@type": "ContactPoint",\n              "email": "support@getmanfred.com",\n              "contactType": "customer service",\n              "availableLanguage": ["Spanish", "English"]\n            }\n          ],\n          "founder": {\n            "@type": "Person",\n            "name": "David Bonilla",\n            "url": "https://twitter.com/david_bonilla>"\n          },\n          "foundingDate": "2019",\n          "areaServed": "Worldwide",\n          "address": {\n            "@type": "PostalAddress",\n            "addressCountry": "ES",\n            "addressRegion": "Madrid",\n            "addressLocality": "Madrid"\n          },\n          "offers": {\n            "@type": "Service",\n            "name": "Plataforma de empleo para el sector tech",\n            "description": "Conectamos profesionales tecnol\xf3gicos con empresas mediante un enfoque centrado en la privacidad y la transparencia."\n          }\n        }'
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_HeadMetadataLangAlternate__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                url: url,
                path: path
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HeadMetadata);


/***/ }),

/***/ 21646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21428);
/* harmony import */ var utils_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75339);




var HeadMetadataLangAlternate = function(param) {
    var url = param.url, path = param.path;
    var getPath = function getPath(path, locale) {
        if (!path) {
            return "";
        }
        return "/".concat((0,services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__/* .getTranslatedText */ .G)(path, locale));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: url && Object.keys(url.langs).map(function(key) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "alternate",
                hrefLang: key,
                href: "".concat(utils_config__WEBPACK_IMPORTED_MODULE_2__/* .config.appUrl */ .v.appUrl, "/").concat(key).concat(url.langs[key]).concat(getPath(path, key))
            }, key);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HeadMetadataLangAlternate);


/***/ }),

/***/ 66334:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ faXTwitter; },
/* harmony export */   "n": function() { return /* binding */ XTwitterIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70865);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49929);



var faXTwitter = {
    prefix: "fab",
    iconName: "x-twitter",
    icon: [
        512,
        512,
        [],
        "f099",
        "M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 240.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"
    ]
};
var XTwitterIcon = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        icon: faXTwitter
    }, props));
};


/***/ }),

/***/ 84110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* reexport safe */ _useFeatureFlag__WEBPACK_IMPORTED_MODULE_0__.y; }
/* harmony export */ });
/* harmony import */ var _useFeatureFlag__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92552);



/***/ }),

/***/ 92552:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ useFeatureFlag; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22970);
/* harmony import */ var context_logged_user_loggeduser_context__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23357);
/* harmony import */ var flagsmith_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98861);
/* harmony import */ var flagsmith_react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(flagsmith_react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);





// Hook.
// -----------------------------------------------------------------------------
var useFeatureFlag = function(feature) {
    // Hooks.
    // ---------------------------------------------------------------------------
    var flags = (0,flagsmith_react__WEBPACK_IMPORTED_MODULE_1__.useFlags)([
        feature
    ]);
    var flagsmith = (0,flagsmith_react__WEBPACK_IMPORTED_MODULE_1__.useFlagsmith)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(!flagsmith.identity), isLoading = ref[0], setIsLoading = ref[1];
    // TODO: We should work with a Manfredite domain object her at some point
    var user = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(context_logged_user_loggeduser_context__WEBPACK_IMPORTED_MODULE_0__/* .LoggedUserContext */ .Vi).user;
    // Functions.
    // ---------------------------------------------------------------------------
    var identify = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
        var email;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(flagsmith.initialised && !flagsmith.identity && user && user.email)) return [
                        3,
                        2
                    ];
                    email = user.email;
                    return [
                        4,
                        flagsmith.identify(email, {
                            email: email,
                            manfrediteId: user.id || null
                        })
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    }), [
        flagsmith,
        user
    ]);
    // Effects.
    // ---------------------------------------------------------------------------
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        identify();
    }, [
        identify
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (flagsmith.initialised) {
            setIsLoading(false);
        }
    }, [
        flagsmith.identity,
        flagsmith.initialised
    ]);
    // Return
    // ---------------------------------------------------------------------------
    return {
        isEnabled: flags[feature].enabled,
        isLoading: isLoading,
        getAllTraits: flagsmith.getAllTraits,
        getTrait: flagsmith.getTrait,
        setTrait: flagsmith.setTrait
    };
};


/***/ }),

/***/ 56002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* reexport */ usePageTrack; }
});

// EXTERNAL MODULE: ./context/logged-user/loggeduser.context.tsx
var loggeduser_context = __webpack_require__(23357);
// EXTERNAL MODULE: ./hooks/useFeatureFlag/index.ts
var useFeatureFlag = __webpack_require__(84110);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./services/service.event-tracking.ts + 1 modules
var service_event_tracking = __webpack_require__(27862);
;// CONCATENATED MODULE: ./hooks/usePageTrack/usePageTrack.ts




var usePageTrack = function(event) {
    var ref = (0,react.useContext)(loggeduser_context/* LoggedUserContext */.Vi), user = ref.user, loadingUser = ref.loadingUser;
    var ref1 = (0,useFeatureFlag/* useFeatureFlag */.y)("talent_manfredite_profile_page_tracking"), isEnabled = ref1.isEnabled, isLoadingFeatureFlag = ref1.isLoading;
    var alreadySent = (0,react.useRef)(false);
    (0,react.useEffect)(function() {
        // Still loading feature flag values
        if (isLoadingFeatureFlag) {
            return;
        }
        // If event is "Public Profile - Page Loaded" and feature flag is disabled, do not track
        var isPublicProfileTrackDisabled = !isLoadingFeatureFlag && !isEnabled && event === "Public Profile - Page Loaded";
        if (isPublicProfileTrackDisabled) {
            return;
        }
        // When user info (if any) is already loaded and event is not tracked yet => Track it
        if (!alreadySent.current) {
            var urlParams = new URLSearchParams(window.location.search);
            // Identify user with campaign traits if user is logged in and campaign exists
            if (urlParams.get("utm_campaign")) {
                identifyUserWithCampaign(urlParams);
            }
            service_event_tracking/* default.page */.Z.page(event, {
                userId: (user === null || user === void 0 ? void 0 : user.id) ? "userId-".concat(user.id) : undefined
            });
            alreadySent.current = true;
        }
    }, [
        loadingUser,
        event,
        user === null || user === void 0 ? void 0 : user.id,
        isLoadingFeatureFlag,
        isEnabled
    ]);
};
function identifyUserWithCampaign(urlParams) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    service_event_tracking/* default.identifyAnonymous */.Z.identifyAnonymous({
        "campaign.name": ((ref = urlParams.get("utm_campaign")) === null || ref === void 0 ? void 0 : ref.toLowerCase()) || undefined,
        "campaign.source": ((ref1 = urlParams.get("utm_source")) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) || undefined,
        "campaign.medium": ((ref2 = urlParams.get("utm_medium")) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase()) || undefined,
        "campaign.term": ((ref3 = urlParams.get("utm_term")) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase()) || undefined,
        "campaign.content": ((ref4 = urlParams.get("utm_content")) === null || ref4 === void 0 ? void 0 : ref4.toLowerCase()) || undefined,
        "campaign.id": ((ref5 = urlParams.get("utm_id")) === null || ref5 === void 0 ? void 0 : ref5.toLowerCase()) || undefined
    });
}

;// CONCATENATED MODULE: ./hooks/usePageTrack/index.ts



/***/ }),

/***/ 69318:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ fredcon25; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../ui-library/dist/index.js + 203 modules
var dist = __webpack_require__(78197);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/free-brands-svg-icons/index.mjs
var free_brands_svg_icons = __webpack_require__(97143);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-solid-svg-icons/index.mjs
var pro_solid_svg_icons = __webpack_require__(54933);
// EXTERNAL MODULE: ./components/shared/XTwitterIcon.tsx
var XTwitterIcon = __webpack_require__(66334);
// EXTERNAL MODULE: ./components/shared/HtmlTrans.tsx
var HtmlTrans = __webpack_require__(97210);
// EXTERNAL MODULE: ./hooks/useI18n/index.ts + 1 modules
var useI18n = __webpack_require__(39105);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(70423);
// EXTERNAL MODULE: ./utils/app-urls.ts
var app_urls = __webpack_require__(62177);
// EXTERNAL MODULE: ./utils/logos.ts
var logos = __webpack_require__(4335);
// EXTERNAL MODULE: ./utils/paths.tsx
var paths = __webpack_require__(64516);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(40286);
// EXTERNAL MODULE: ./theme/index.js + 247 modules
var theme = __webpack_require__(90408);
;// CONCATENATED MODULE: ./components/marketingSite/fredcon25/Fredcon25.styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  body {\n    background-color: #EBF1FF;\n    color: #1117D7;\n    min-height: 100vh;\n    font-family: "IBM Plex Sans", sans-serif;\n    font-weight: 400;\n    font-style: normal;\n  }\n'
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  h1 {\n    font-size: 128px;\n    line-height: 1;\n    position: relative;\n    margin-bottom: 0.25rem;\n\n    :after {\n      content: '';\n      display: inline-block;\n      margin-left: 1.5rem;\n      background: url('/images/fredcon25/logo.png') no-repeat 0 0;\n      width: 115px;\n      height: 115px;\n      margin-bottom: -1.5rem;\n    }\n\n    @media (max-width: ",
        ") {\n      font-size: 75px;\n    }\n\n    @media (max-width: ",
        ") {\n      font-size: 50px;\n      text-align: center;\n      display: flex;\n      flex-direction: column;\n      gap: 0.25rem;\n      margin-bottom: 0.75rem;\n\n      :after {\n        margin: 1rem auto 0 auto;\n      }\n    }\n  }\n\n  h1 span {\n    display: block;\n    font-weight: normal;\n    font-size: ",
        ";\n  }\n\n  h2 {\n    font-size: 50px;\n    line-height: 1;\n    position: relative;\n    margin-bottom: 1.5rem;\n\n    @media (max-width: ",
        ") {\n      font-size: 42px;\n    }\n\n    @media (max-width: ",
        ") {\n      font-size: 28px;\n    }\n  }\n\n  section {\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: #1117d7;\n  border: 2px solid #1117d7;\n  color: #fff;\n  text-transform: uppercase;\n  font-weight: 700;\n  padding: ",
        " ",
        ";\n  border-radius: 35px;\n  display: inline-flex;\n  gap: 0.5rem;\n  text-wrap: nowrap;\n\n  &:focus,\n  &:hover {\n    color: #fff;\n    border: 2px solid #becffe;\n  }\n\n  @media (max-width: ",
        ") {\n    font-size: ",
        ";\n    gap: 0.15rem;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column-reverse;\n  gap: 0;\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: #becffe;\n  font-size: ",
        ";\n  padding: ",
        " 0;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  box-shadow: ",
        ";\n  padding: ",
        " 0;\n\n  .nav a {\n    color: #1117d7;\n    font-weight: 700;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n\n  @media (max-width: ",
        ") {\n    .nav {\n      display: none;\n    }\n  }\n\n  @media (max-width: ",
        ") {\n    .nav {\n      text-align: left;\n    }\n\n    .header {\n      flex-direction: row;\n    }\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  img {\n    height: 40px;\n    display: block;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 1rem;\n  position: relative;\n  display: inline-block;\n  margin-top: 5rem;\n\n  .title-img {\n    display: block;\n    max-width: 100%;\n    height: auto;\n    margin-top: 0.5rem;\n  }\n\n  .logo-img {\n    position: absolute;\n    left: 52%;\n    top: -50%;\n    transform: translateX(-50%);\n    pointer-events: none; /* optional */\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  margin-bottom: 1.5rem;\n\n  @media (max-width: ",
        ") {\n    text-align: center;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  background-color: #fff;\n  padding: 0.75rem 1rem;\n  border-radius: 10px;\n  margin-bottom: 1.5rem;\n\n  @media (max-width: ",
        ") {\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  flex: 0 0 31%;\n\n  @media (max-width: ",
        ") {\n    flex: 0 0 48%;\n  }\n\n  @media (max-width: ",
        ") {\n    flex: 0 0 100%;\n  }\n\n  img {\n    height: 142px;\n    width: 142px;\n\n    @media (max-width: ",
        ") {\n      height: 100px;\n      width: 100px;\n    }\n\n    @media (max-width: ",
        ") {\n      height: 75px;\n      width: 75px;\n    }\n  }\n\n  strong {\n    display: block;\n    margin-bottom: 0.25rem;\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: #becffe;\n  height: 142px;\n  width: 142px;\n  border-radius: 100%;\n\n  @media (max-width: ",
        ") {\n    height: 100px;\n    width: 100px;\n  }\n\n  @media (max-width: ",
        ") {\n    height: 75px;\n    width: 75px;\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 65%;\n\n  @media (max-width: ",
        ") {\n    width: 100%;\n  }\n\n  p {\n    line-height: 1.75;\n\n    @media (max-width: ",
        ") {\n      line-height: 1.5;\n    }\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  strong,\n  span {\n    display: block;\n    margin-bottom: 0.5rem;\n  }\n\n  iframe {\n    width: 65%;\n    border-radius: 10px;\n  }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 1rem;\n\n  @media (max-width: ",
        ") {\n    flex-direction: column;\n\n    iframe {\n      width: 100%;\n    }\n  }\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  display: flex;\n  align-items: center;\n  border-radius: 10px;\n  padding: ",
        " ",
        ";\n  gap: 1.5rem;\n\n  @media (max-width: ",
        ") {\n    flex-direction: column;\n    content-justify: flex-start;\n    align-items: flex-start;\n    gap: 0.75rem;\n  }\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: right;\n  flex: 0 0 15%;\n\n  @media (max-width: ",
        ") {\n    text-align: left;\n  }\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  strong {\n    display: block;\n    margin-bottom: 0.25rem;\n  }\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  p {\n    line-height: 1.75;\n\n    @media (max-width: ",
        ") {\n      line-height: 1.5;\n    }\n  }\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: #becffe;\n  border-radius: 10px;\n  min-height: 352px;\n  width: 232px;\n  padding: ",
        ";\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n\n  @media (max-width: ",
        ") {\n    width: auto;\n    margin: 0 2rem;\n\n    img {\n      width: 100%;\n    }\n  }\n\n  a {\n    color: #1117d7;\n  }\n\n  strong {\n    display: block;\n    margin-bottom: 0.25rem;\n  }\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 10px;\n  padding: ",
        ";\n  padding-right: 450px;\n  background: #becffe url('/images/fredcon25/people.svg') no-repeat 100% 100%;\n  background-size: 400px;\n\n  @media (max-width: ",
        ") {\n    padding-right: 250px;\n    background-size: 250px;\n  }\n\n  @media (max-width: ",
        ") {\n    background-position: 50% 100%;\n    padding-right: ",
        ";\n    padding-bottom: 200px;\n  }\n\n  h1 {\n    font-size: 50px;\n    margin-top: 0;\n\n    &:after {\n      display: none;\n    }\n  }\n\n  p {\n    line-height: 1.75;\n\n    @media (max-width: ",
        ") {\n      line-height: 1.5;\n    }\n  }\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-bottom: 2px solid #93a9fd;\n  padding-bottom: 2rem;\n\n  > div {\n    text-align: center;\n  }\n"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1 1 23%;\n  margin: 1.5rem 0;\n"
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-bottom: 2rem;\n"
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  text-align: center;\n\n  p {\n    line-height: 1.75;\n\n    @media (max-width: ",
        ") {\n      line-height: 1.5;\n    }\n\n    a {\n      color: #1117d7;\n      font-weight: bold;\n\n      &:focus,\n      &:hover {\n        text-decoration: underline;\n      }\n    }\n  }\n"
    ]);
    _templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: #fff;\n  border-radius: 10px;\n  padding: ",
        ";\n  margin-top: 4rem;\n\n  h1 {\n    font-size: 30px;\n    margin-top: 0.25rem;\n\n    :after {\n      height: 75px;\n      width: 75px;\n      background-size: 75px;\n      margin-top: -35px;\n\n      @media (max-width: ",
        ") {\n        padding-bottom: 75px;\n        margin-top: 0;\n        margin-bottom: 0;\n      }\n    }\n  }\n\n  nav {\n    font-size: ",
        ";\n    text-align: center;\n    margin-top: 3rem;\n    display: flex;\n    gap: 1.5rem;\n    align-items: center;\n    justify-content: center;\n\n    @media (max-width: ",
        ") {\n      flex-direction: column;\n    }\n\n    a {\n      font-weight: 700;\n      color: #1117d7;\n\n      &:hover {\n        text-decoration: underline;\n      }\n    }\n  }\n"
    ]);
    _templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}


var Fredon25GlobalStyles = (0,styled_components_browser_esm/* createGlobalStyle */.vJ)(_templateObject());
var Root = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-889aa32d-0"
})(_templateObject1(), (0,theme/* screen */.sp)("lg"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("md"), (0,theme/* screen */.sp)("lg"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl4"));
var Fredcon25_styled_GetTicketButton = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-889aa32d-1"
})(_templateObject2(), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("xs"));
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-889aa32d-2"
})(_templateObject3(), (0,theme/* container */.nC)("xl"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"));
// Header -------
var Header = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
    componentId: "sc-889aa32d-3"
})(_templateObject4(), (0,theme/* spacing */.W0)("xl"));
var HeaderContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-889aa32d-4"
})(_templateObject5(), (0,theme/* container */.nC)("xlMax"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"));
var HeaderNotice = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-889aa32d-5"
})(_templateObject6(), (0,theme/* fontSize */.JB)("sm"), (0,theme/* spacing */.W0)("sm"));
var HeaderNav = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-889aa32d-6"
})(_templateObject7(), (0,theme/* color */.$_)("white"), (0,theme/* shadow */.AF)("md"), (0,theme/* spacing */.W0)("sm"), (0,theme/* screen */.sp)("md"), (0,theme/* screen */.sp)("md"));
var HeaderNavLogo = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-889aa32d-7"
})(_templateObject8());
// /Header -------
// Hero -------
var Hero = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-889aa32d-8"
})(_templateObject9());
var HeroTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-889aa32d-9"
})(_templateObject10());
var HeroDesc = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-889aa32d-10"
})(_templateObject11(), (0,theme/* fontSize */.JB)("xl2"), (0,theme/* screen */.sp)("md"));
var HeroDate = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-889aa32d-11"
})(_templateObject12(), (0,theme/* screen */.sp)("md"));
var HeroHost = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-889aa32d-12"
})(_templateObject13(), (0,theme/* screen */.sp)("lg"), (0,theme/* screen */.sp)("md"), (0,theme/* screen */.sp)("lg"), (0,theme/* screen */.sp)("md"));
var HeroHostTBA = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-889aa32d-13"
})(_templateObject14(), (0,theme/* screen */.sp)("lg"), (0,theme/* screen */.sp)("md"));
// /Hero -------
// What -------
var What = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-889aa32d-14"
})(_templateObject15(), (0,theme/* screen */.sp)("md"), (0,theme/* screen */.sp)("lg"));
var WhatDesc = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-889aa32d-15"
})(_templateObject16());
// /What -------
// Where -------
var Where = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-889aa32d-16"
})(_templateObject17());
var WhereDesc = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-889aa32d-17"
})(_templateObject18());
var WhereWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-889aa32d-18"
})(_templateObject19(), (0,theme/* screen */.sp)("md"));
// /Where -------
// Agenda -------
var Agenda = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-889aa32d-19"
})(_templateObject20());
var AgendaItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-889aa32d-20"
})(_templateObject21(), function(param) {
    var isBreak = param.isBreak;
    return isBreak ? "transparent" : "#BECFFE";
}, function(param) {
    var isBreak = param.isBreak;
    return isBreak ? "0" : (0,theme/* spacing */.W0)("lg");
}, (0,theme/* spacing */.W0)("lg"), (0,theme/* screen */.sp)("md"));
var AgendaItemTime = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-889aa32d-21"
})(_templateObject22(), (0,theme/* screen */.sp)("md"));
var AgendaItemContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-889aa32d-22"
})(_templateObject23());
// /Agenda -------
// Speakers -------
var Speakers = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-889aa32d-23"
})(_templateObject24());
var SpeakersDesc = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-889aa32d-24"
})(_templateObject25(), (0,theme/* screen */.sp)("lg"));
var Speaker = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-889aa32d-25"
})(_templateObject26(), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("md"));
// /Speakers -------
// Tickets -------
var Tickets = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-889aa32d-26"
})(_templateObject27());
var TicketsWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-889aa32d-27"
})(_templateObject28(), (0,theme/* spacing */.W0)("xl2"), (0,theme/* screen */.sp)("lg"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* screen */.sp)("lg"));
var TicketsDesc = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-889aa32d-28"
})(_templateObject29());
// /Tickets -------
// Partners -------
var Partners = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-889aa32d-29"
})(_templateObject30());
var Partner = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-889aa32d-30"
})(_templateObject31());
// /Partners -------
// Footer -------
var Footer = styled_components_browser_esm/* default.footer.withConfig */.ZP.footer.withConfig({
    componentId: "sc-889aa32d-31"
})(_templateObject32());
var FooterContact = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-889aa32d-32"
})(_templateObject33(), (0,theme/* fontSize */.JB)("lg"), (0,theme/* screen */.sp)("lg"));
var FooterInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-889aa32d-33"
})(_templateObject34(), (0,theme/* spacing */.W0)("xl3"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("xs"), (0,theme/* screen */.sp)("md")); // /Footer -------

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ./components/marketingSite/fredcon25/Fredcon25.tsx















var Fredcon25 = function() {
    var t = (0,useI18n/* useI18n */.Q)("fredcon25").t;
    var locale = (0,router.useRouter)().locale;
    var GetTicketButton = /*#__PURE__*/ (0,jsx_runtime.jsxs)(Fredcon25_styled_GetTicketButton, {
        href: "https://getmanfred.typeform.com/fredcon",
        target: "_blank",
        children: [
            t("fredcon.get-ticket"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Icon */.JO, {
                icon: pro_solid_svg_icons/* faArrowRight */.eFW
            })
        ]
    });
    var agenda = [
        {
            break: false
        },
        {
            break: false
        },
        {
            break: false
        },
        {
            break: false
        },
        {
            break: false
        },
        {
            break: true
        },
        {
            break: false
        },
        {
            break: false
        },
        {
            break: false
        },
        {
            break: false
        },
        {
            break: true
        },
        {
            break: false
        },
        {
            break: false
        },
        {
            break: false
        },
        {
            break: false
        },
        {
            break: false
        },
        {
            break: true
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Root, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Fredon25GlobalStyles, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderNav, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderContainer, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Stack */.Kq, {
                                alignment: "center",
                                contentAlign: "space-between",
                                className: "header",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Stack */.Kq, {
                                        alignment: "center",
                                        gap: "5xl",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: (0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.home */.uu.home, locale),
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderNavLogo, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: logos/* LOGO_MANFRED */.$q,
                                                        alt: "Manfred logo",
                                                        className: "brand"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Stack */.Kq, {
                                                className: "nav",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Link */.rU, {
                                                        href: "#agenda",
                                                        to: "agenda",
                                                        children: t("fredcon.header.nav-1")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Link */.rU, {
                                                        href: "#donde",
                                                        to: "donde",
                                                        children: t("fredcon.header.nav-2")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Link */.rU, {
                                                        href: "#speakers",
                                                        to: "speakers",
                                                        children: t("fredcon.header.nav-3")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Link */.rU, {
                                                        href: "#entradas",
                                                        to: "entradas",
                                                        children: t("fredcon.header.nav-4")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Link */.rU, {
                                                        href: "#contacto",
                                                        to: "contacto",
                                                        children: t("fredcon.header.nav-5")
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    GetTicketButton
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderNotice, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderContainer, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                ns: "fredcon25",
                                i18nKey: "fredcon.header.notice"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hero, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeroTitle, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: t("fredcon.hero.title-pre")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: (0,paths/* getPublicPath */.A)("/images/fredcon25/title.png"),
                                        alt: t("fredcon.hero.title"),
                                        className: "title-img"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: (0,paths/* getPublicPath */.A)("/images/fredcon25/logo.png"),
                                        alt: t("fredcon.hero.logo"),
                                        className: "logo-img"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroDesc, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                    ns: "fredcon25",
                                    i18nKey: "fredcon.hero.desc"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroDate, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                    ns: "fredcon25",
                                    i18nKey: "fredcon.hero.date"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Stack */.Kq, {
                        wrap: true,
                        children: Array.from({
                            length: 10
                        }).map(function(_, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeroHost, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: (0,paths/* getPublicPath */.A)("/images/fredcon25/host-".concat(index + 1, ".png")),
                                        alt: t("fredcon.hero.hosts.host-".concat(index + 1, ".name"))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                children: t("fredcon.hero.hosts.host-".concat(index + 1, ".name"))
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: t("fredcon.hero.hosts.host-".concat(index + 1, ".desc"))
                                            })
                                        ]
                                    })
                                ]
                            }, index);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(What, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: t("fredcon.what.title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(WhatDesc, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                    ns: "fredcon25",
                                    i18nKey: "fredcon.what.desc"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Where, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
                                name: "donde",
                                id: "donde"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: t("fredcon.where.title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(WhereWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WhereDesc, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                            ns: "fredcon25",
                                            i18nKey: "fredcon.where.desc"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                        src: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3037.9897840543754!2d-3.7068436000000005!3d40.4090771!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd4227fc14e5d533%3A0xd840f5b434384bc7!2sEspacio%20Rastro%20Madrid!5e0!3m2!1sen!2ses!4v1747216832762!5m2!1sen!2ses",
                                        style: {
                                            border: 0
                                        },
                                        allowFullScreen: false,
                                        loading: "lazy",
                                        referrerPolicy: "no-referrer-when-downgrade"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Agenda, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
                                name: "agenda",
                                id: "agenda"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: t("fredcon.agenda.title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Stack */.Kq, {
                                direction: "column",
                                children: agenda.map(function(item, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AgendaItem, {
                                        isBreak: item.break,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AgendaItemTime, {
                                                children: t("fredcon.agenda.agenda-".concat(index + 1, ".time"))
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AgendaItemContent, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                                    ns: "fredcon25",
                                                    i18nKey: "fredcon.agenda.agenda-".concat(index + 1, ".content")
                                                })
                                            })
                                        ]
                                    }, index);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Speakers, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
                                name: "speakers",
                                id: "speakers"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: t("fredcon.speakers.title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SpeakersDesc, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                    ns: "fredcon25",
                                    i18nKey: "fredcon.speakers.desc"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Stack */.Kq, {
                                wrap: true,
                                gap: "l",
                                children: Array.from({
                                    length: 11
                                }).map(function(_, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Speaker, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: (0,paths/* getPublicPath */.A)("/images/fredcon25/speaker-".concat(index + 1, ".png")),
                                                        alt: t("fredcon.speakers.speaker-".concat(index + 1, ".name"))
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                children: t("fredcon.speakers.speaker-".concat(index + 1, ".name"))
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: t("fredcon.speakers.speaker-".concat(index + 1, ".desc"))
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: t("fredcon.speakers.speaker-".concat(index + 1, ".linkedin")),
                                                target: "_blank",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Icon */.JO, {
                                                    icon: free_brands_svg_icons/* faLinkedin */.D9H,
                                                    size: "xl"
                                                })
                                            })
                                        ]
                                    }, index);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tickets, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
                                name: "entradas",
                                id: "entradas"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: t("fredcon.tickets.title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TicketsWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: t("fredcon.hero.title-pre")
                                    }),
                                    " ",
                                    t("fredcon.hero.title"),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketsDesc, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                            ns: "fredcon25",
                                            i18nKey: "fredcon.tickets.desc"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: GetTicketButton
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Partners, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
                                name: "partners",
                                id: "partners"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: t("fredcon.partners.title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Stack */.Kq, {
                                direction: "column",
                                gap: "l",
                                children: [
                                    3,
                                    3,
                                    4
                                ].reduce(function(acc, size, rowIndex) {
                                    var rowItems = acc.remaining.slice(0, size);
                                    acc.remaining = acc.remaining.slice(size);
                                    acc.rows.push(rowItems);
                                    return acc;
                                }, {
                                    rows: [],
                                    remaining: Array.from({
                                        length: 10
                                    }, function(_, i) {
                                        return i + 1;
                                    })
                                }).rows.map(function(row, rowIndex) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Stack */.Kq, {
                                        wrap: true,
                                        gap: "l",
                                        alignment: "center",
                                        children: row.map(function(partnerIndex) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Partner, {
                                                href: t("fredcon.partners.partner-".concat(partnerIndex, ".url")),
                                                target: "_blank",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: (0,paths/* getPublicPath */.A)("/images/fredcon25/partner-".concat(partnerIndex, ".svg")),
                                                    alt: t("fredcon.partners.partner-".concat(partnerIndex, ".name"))
                                                })
                                            }, partnerIndex);
                                        })
                                    }, rowIndex);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Footer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
                                name: "contacto",
                                id: "contacto"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterContact, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                    ns: "fredcon25",
                                    i18nKey: "fredcon.footer.contact"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterInfo, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Stack */.Kq, {
                                        contentAlign: "space-between",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: t("fredcon.hero.title-pre")
                                                    }),
                                                    " ",
                                                    t("fredcon.hero.title")
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: (0,paths/* getPublicPath */.A)("/images/fredcon25/manfred-tecnofor.svg"),
                                                alt: "Manfred + Tecnofor"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                children: [
                                                    "\xa9 ",
                                                    new Date().getFullYear(),
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                        children: "Manfred Tech"
                                                    }),
                                                    " S.L."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: (0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.termsOfUse */.uu.termsOfUse),
                                                target: "_blank",
                                                children: t("fredcon.footer.nav.terms")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: (0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.privacyPolicy */.uu.privacyPolicy),
                                                target: "_blank",
                                                children: t("fredcon.footer.nav.privacy")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: (0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.cookies */.uu.cookies),
                                                target: "_blank",
                                                children: t("fredcon.footer.nav.cookies")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "https://twitter.com/getmanfred",
                                                target: "_blank",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Icon */.JO, {
                                                    icon: XTwitterIcon/* faXTwitter */.N,
                                                    size: "l"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "https://t.me/getmanfred",
                                                target: "_blank",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Icon */.JO, {
                                                    icon: free_brands_svg_icons/* faTelegram */.Uv8,
                                                    size: "l"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/marketingSite/fredcon25/index.ts


// EXTERNAL MODULE: ./components/shared/HeadMetadata.tsx
var HeadMetadata = __webpack_require__(73412);
// EXTERNAL MODULE: ./hooks/usePageTrack/index.ts + 1 modules
var usePageTrack = __webpack_require__(56002);
;// CONCATENATED MODULE: ./pages/fredcon25.tsx







var ManTechCar25Page = function(param) {
    var baseUrl = param.baseUrl;
    var t = (0,useI18n/* useI18n */.Q)("fredcon25").t;
    (0,usePageTrack/* usePageTrack */.N)("Landing - Page Loaded");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "preconnect",
                href: "https://fonts.googleapis.com"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "preconnect",
                href: "https://fonts.gstatic.com",
                crossOrigin: ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                href: "https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;1,100;1,200;1,300;1,400;1,500;1,600;1,700&display=swap",
                rel: "stylesheet"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadMetadata/* default */.Z, {
                title: t("fredcon.page_title"),
                url: app_urls/* APP_URLS.fredcon25 */.uu.fredcon25,
                desc: t("fredcon.page_description"),
                imgUrl: "".concat(baseUrl).concat((0,paths/* getPublicPath */.A)("/images/cards/card_fredcon25.png"))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "canonical",
                href: "https://fredcon.io/fredcon25"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Fredcon25, {})
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var fredcon25 = (ManTechCar25Page);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(50951); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);